import apiFetch from './client';

export function createSession(data) {
  return apiFetch('/api/sessions/', { method: 'POST', body: JSON.stringify(data) });
}

export function completeSession(sessionId) {
  return apiFetch(`/api/sessions/${sessionId}/complete`, { method: 'PUT' });
}

export function saveSessionFeedback(sessionId, data) {
  return apiFetch(`/api/sessions/${sessionId}/feedback`, { method: 'PUT', body: JSON.stringify(data) });
}

export function getSessionStats(weeks) {
  return apiFetch(`/api/sessions/stats?weeks=${weeks}`);
}
